export default {
  cash: 1,
  card: 2,
  youZan: 3,
  applet: 4,
  transfer: 5,
  douYin: 6,
  weChat: 7,
  alipay: 8,
  meituan: 9,
  xiaoHongShu: 11,
}
